<template>
  <v-container fluid class="pa-0 mt-3">
    <order-review
      v-if="toConfirm"
      :show-title="false"
      @orderReview="onOrderReview"
      @orderCreated="onOrderCreated"
      @orderUpdated="onOrderUpdated"
      @editContact="onOrderReview"
      @editLocation="onOrderReview"
      @editPayment="onOrderReview"
      @editProducts="onOrderReview"
      btn-review
    ></order-review>

    <bar-order
      v-else-if="orderSystemIsReady"
      @confirmOrder="toConfirm = true"
    ></bar-order>
  </v-container>
</template>

<script>
import BarOrder from "@/modules/delivery/components-core/business/BarOrder/BarOrder.vue";
import { BAR, SALON } from "@/modules/delivery/constants/OrderOrigin";
import OrderProvider from "@/modules/delivery/providers/OrderProvider";
import OrderReview from "@/modules/delivery/components-core/shared/OrderReview/OrderReview.vue";

export default {
  name: "BarOrderPage",
  components: { OrderReview, BarOrder },
  created() {
    switch (this.$route.name) {
      case "BarOrderEditPage":
        this.initEdit();
        break;
      case "BarOrderPage":
        this.initCreate(BAR);
        break;
      case "SalonOrderPage":
        this.initCreate(SALON);
        break;
    }
  },
  data() {
    return {
      toConfirm: false,
    };
  },
  computed: {
    orderSystemIsReady() {
      return this.$store.getters.orderSystem.isSystemReady;
    },
    orderIdentifier() {
      return this.$route.params.identifier;
    },
  },
  methods: {
    initCreate(origin) {
      this.$store.commit("clearOrder");
      this.$store.dispatch("initOrder", { origin: origin });
      this.$store.dispatch("setupOrderSystem");
      this.$store.dispatch("fetchDefaultBranch");
    },
    async initEdit() {
      let r = await OrderProvider.orderFindByIdentifier(this.orderIdentifier);
      const order = r.data.orderFindByIdentifier;
      this.$store.commit("setEditing", true);
      this.$store.commit("branchSelected", order.branch);
      this.$store.commit("setupOrder", order);
      await this.$store.dispatch("setupOrderSystem");
    },
    onOrderReview() {
      this.toConfirm = false;
      setTimeout(() => {
        this.$vuetify.goTo("#top");
      }, 100);
    },
    onOrderCreated(order) {
      if (order.origin === "SALON") {
        this.$router.push({
          name: "SalonOrderViewPage",
          params: { identifier: order.identifier },
        });
      } else {
        this.$router.push({
          name: "BarOrderViewPage",
          params: { identifier: order.identifier },
        });
      }
    },
    onOrderUpdated(order) {
      if (order.origin === "SALON") {
        this.$router.push({
          name: "SalonOrderViewPage",
          params: { identifier: order.identifier },
        });
      } else {
        this.$router.push({
          name: "BarOrderViewPage",
          params: { identifier: order.identifier },
        });
      }
    },
  },
};
</script>

<style scoped></style>
